<template>
    <div class="content">
        <header>
            <div class="banner">
                <van-row>
                    <van-col span="6" @click="back"><img class="back-icon"
                                                         :src="require(`@/assets/theme/${theme}/status/01dailyActive/01back.svg`)">
                    </van-col>
                    <van-col span="12">
                        <div class="banner-title">{{ $t('nfc.title') }}</div>
                    </van-col>
                </van-row>
            </div>
        </header>
        <div class="desc-box">
            <div class="desc-title">{{$t('nfc.title1')}}</div>
            <div class="desc-info">{{$t('nfc.p1')}}</div>
            <div class="desc-info">{{$t('nfc.p2')}}</div>
            <div class="desc-title">{{$t('nfc.title2')}}</div>
            <div class="desc-info">{{$t('nfc.p3')}}</div>
            <div class="desc-title">{{$t('nfc.title3')}}</div>
            <div class="desc-info">{{$t('nfc.p4')}}</div>
            <div class="desc-title">{{$t('nfc.title4')}}</div>
            <div class="desc-info">{{$t('nfc.p5')}}</div>
            <div class="desc-title">{{$t('nfc.title5')}}</div>
            <div class="desc-info last-desc">{{$t('nfc.p6')}}</div>
        </div>
    </div>
</template>

<script>
import {WebJSBridge} from "../../utils/JSBridge1";

export default {
    name: '03hrDesc',
    data() {
        return {
            theme: ''
        }
    },
    mounted() {
        if (this.$route.query.theme) {
            this.theme = this.$route.query.theme;
        }
    },
    methods: {
        back() {
            WebJSBridge.call("closeWeb", null, function (res) {
            });
        }
    }
}
</script>

<style scoped>
.content {
    width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/views/common/nfc.vue